// extracted by mini-css-extract-plugin
export default {"latestSection":"LatestSection_latestSection__C3e5z"};